import { useState, useEffect } from 'react';
import {
  getFormVersion,
  onFormChanged,
  getViewVersion,
  onViewChanged,
} from '../registry/loaderRegistry';

export function useFormSchemaVersion(): number {
  const [version, setVersion] = useState(getFormVersion);
  useEffect(() => onFormChanged(() => setVersion(getFormVersion())), []);
  return version;
}

export function useViewSchemaVersion(): number {
  const [version, setVersion] = useState(getViewVersion);
  useEffect(() => onViewChanged(() => setVersion(getViewVersion())), []);
  return version;
}
